import { useState } from "react";

const STORAGE_KEY = "neluminar_cookie_notice_2026_09_25";

function wasAcknowledged(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "acknowledged";
  } catch {
    return false;
  }
}

export function CookieNotice() {
  const [visible, setVisible] = useState(() => !wasAcknowledged());
  if (!visible) return null;

  const acknowledge = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "acknowledged");
    } catch {
      // The notice can still be dismissed in privacy-restricted browsers.
    }
    setVisible(false);
  };

  return (
    <section className="cookie-notice" role="region" aria-label="Использование cookies">
      <p>
        Мы используем только необходимые cookies для входа, защиты форм и работы
        аккаунта. <a href="/legal/cookies">Подробнее</a>
      </p>
      <button type="button" onClick={acknowledge}>Понятно</button>
    </section>
  );
}
